export function dependentChoiceLabel(
  isDependent: boolean | string | undefined | null
): 'Yes' | 'No' {
  return isDependent === true || isDependent === 'true' ? 'Yes' : 'No';
}

/**
 * Omit dependentChoice only for the initial untouched state (boolean `false` default).
 * String `"false"` from the "No" radio is truthy and must still be tracked as No.
 */
export function shouldIncludeDependentChoiceAnalytics(
  isDependent: boolean | string | undefined | null
): boolean {
  return !(isDependent === false && typeof isDependent === 'boolean');
}
